<template>
    <div class="proposal">
        <div class='second_banner'>
            <img class="banner_img" src="../assets/img/proposal_banner.png" alt="">
        </div>
        <div class="proposal_content">
            <div class="container animated fadeInUp">
               <div class="proposal_item">
                   <img src="../assets/img/proposal1.png" alt="">
               </div>
               <div class="proposal_item">
                   <img src="../assets/img/proposal2.png" alt="">
               </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name:'proposal',
       
    }
</script>

<style lang="less" scoped>
.proposal_content{
    width: 100%;
    // height: 1120px;
    .container{
        padding:160px 0;
        text-align: center;
        display: flex;
        .proposal_item{
            flex:1;
            margin:0 5px;
            img{
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>